export default __webpack_public_path__ + "static/media/Provider_language.05768467.svg";